import axios from "axios";
import { Dispatch } from "redux";
import {
  PayoutTypes,
  SAVE_PAYOUT_ACCOUNT,
  SAVE_PAYOUT_ACCOUNT_SUCCESS,
  SAVE_PAYOUT_ACCOUNT_FAILURE,
  PAYOUT_ACCOUNT,
  PAYOUT_ACCOUNT_SUCCESS,
  PAYOUT_ACCOUNT_FAILURE,
  MANUAL_PAYMENT,
  MANUAL_PAYMENT_SUCCESS,
  MANUAL_PAYMENT_FAILURE,
  OTHER_PAYMENT,
  OTHER_PAYMENT_SUCCESS,
  OTHER_PAYMENT_FAILURE,
  CARD_PAYMENT,
  CARD_PAYMENT_SUCCESS,
  CARD_PAYMENT_FAILURE,
  RESET_PAYOUT,
} from "../types/payoutType";

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

API.defaults.withCredentials = true;

export const addPaymentAccount =
  (data: any) => async (dispatch: Dispatch<PayoutTypes>) => {
    try {
      dispatch({ type: SAVE_PAYOUT_ACCOUNT, payload: [] });

      const response = await API.post("/customer/save-payout-account", data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.status) {
        dispatch({ type: SAVE_PAYOUT_ACCOUNT_SUCCESS, payload: response.data });
      } else {
        dispatch({
          type: SAVE_PAYOUT_ACCOUNT_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: SAVE_PAYOUT_ACCOUNT_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const getPaymentAccount =
  (data: any) => async (dispatch: Dispatch<PayoutTypes>) => {
    try {
      dispatch({ type: PAYOUT_ACCOUNT, payload: [] });
      const response = await API.get("/customer/payout-accounts", {
        params: data,
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.status) {
        dispatch({ type: PAYOUT_ACCOUNT_SUCCESS, payload: response.data });
      } else {
        dispatch({
          type: PAYOUT_ACCOUNT_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: PAYOUT_ACCOUNT_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const manualPayment =
  (data: any) => async (dispatch: Dispatch<PayoutTypes>) => {
    try {
      dispatch({ type: MANUAL_PAYMENT, payload: [] });

      const response = await API.post(
        "/customer/initiate/manual-payment",
        data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      if (response.status) {
        dispatch({ type: MANUAL_PAYMENT_SUCCESS, payload: response.data });

        window.location.href = `/pages/payment-pending`;
        // ?id=${response.data.data.id}
      } else {
        dispatch({
          type: MANUAL_PAYMENT_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: MANUAL_PAYMENT_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const otherPayment =
  (data: any) => async (dispatch: Dispatch<PayoutTypes>) => {
    try {
      dispatch({ type: OTHER_PAYMENT, payload: [] });

      const response = await API.post("/customer/payments/pay-later", data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      if (response.status) {
        dispatch({ type: OTHER_PAYMENT_SUCCESS, payload: response.data });

        window.location.href = `/pages/payment-pending`;
      } else {
        dispatch({
          type: OTHER_PAYMENT_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: OTHER_PAYMENT_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const cardPayment =
  (data: any) => async (dispatch: Dispatch<PayoutTypes>) => {
    try {
      dispatch({ type: CARD_PAYMENT, payload: [] });


      const response = await API.post("/customer/payments/card", data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
 
      if (response.status) {
        dispatch({ type: CARD_PAYMENT_SUCCESS, payload: response.data });
 
        window.location.href = `/pages/payment-pending`;

 
      } else {
        dispatch({
          type: CARD_PAYMENT_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: CARD_PAYMENT_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const resetPaymentAccount = () => (dispatch: Dispatch<PayoutTypes>) => {
  dispatch({ type: RESET_PAYOUT });
};
